// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2zsUs","column":"style_column__dMQgs","row":"style_row__1d-ee"};